import React from 'react';
export function ThumbsDownIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.445 21.832a1 1 0 001.45-.385L17.617 14H21a2 2 0 002-2V4a2 2 0 00-2-2H4.847a2 2 0 00-1.973 1.671l-1.666 10A2 2 0 003.18 16H9v2.465a2 2 0 00.89 1.664l2.555 1.703zM16 4H4.847L3.18 14H10a1 1 0 011 1v3.465l1.612 1.075L16 12.764V4zm5 8h-3V4h3v8z"
  }));
}